import { HTMLAttributes } from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

import { Icon } from '../icon/Icon';
import { ReactComponent as DoneIcon } from './assets/done-loading.svg';
import { ReactComponent as SpinnerIcon } from './assets/spinner.svg';

export interface LabelProps extends HTMLAttributes<HTMLDivElement> {
  iconLeft?: string;
  iconRight?: string;
}

const BaseLabel = tw.div`inline-flex items-center flex-nowrap outline-none px-1 justify-center rounded whitespace-nowrap select-none bg-white font-medium text-gray-50 text-sm shadow-card`;

export const Label = ({ iconLeft, iconRight, children, ...props }: LabelProps) => (
  <BaseLabel {...props}>
    {iconLeft && <Icon name={iconLeft} tw="mr-1 leading-none text-base" />}
    {children}
    {iconRight && <Icon name={iconRight} tw="ml-1 leading-none text-base text-current" />}
  </BaseLabel>
);

export interface LoadingLabelProps extends HTMLAttributes<HTMLDivElement> {
  loading?: boolean;
}

export const LoadingLabel = ({ loading, children, ...props }: LoadingLabelProps) => (
  <BaseLabel
    tw="transition duration-fast shadow-none py-[6px]"
    css={loading ? [tw`bg-gray-5`] : [tw`bg-secondary`]}
    {...props}
  >
    {loading ? (
      <SpinnerIcon role="alert" aria-busy tw="h-3 w-3 animate-spin text-secondary fill-current" />
    ) : (
      <DoneIcon role="alert" aria-busy="false" tw="h-3 w-3 text-secondary stroke-current" />
    )}
    {
      <div tw="px-1 display-6" css={loading ? [tw`text-secondary`] : [tw`text-white`]}>
        {children}
      </div>
    }
  </BaseLabel>
);
